<template>
  <b-card no-body>
    <b-overlay :show="loading_analyte_ranges" class="animated">
      <b-card-body>

        <b-row class="mb-3 font-weight-bolder">
          <b-col>
            Feed Type
          </b-col>
          <b-col md="2">
            Low
          </b-col>
          <b-col md="2">
            High
          </b-col>
          <b-col md="1" />
        </b-row>

        <template v-if="analyte_ranges && analyte_ranges.length">
          <AnalyteRangeFormRow
            v-for="(item, index) in analyte_ranges"
            :key="'range' + index"
            :index="index"
            :item="item"
            :fields="[
              { name: 'attribute_list_id' },
              { name: 'low', md: 2 },
              { name: 'high', md: 2 }
            ]"
            class="mb-2 py-2 align-items-center"
            @refresh="$emit('refresh')"
          >
            <template #field(attribute_list_id)="{ row }">
              {{ row.attribute_list ? row.attribute_list.value : '' }}
            </template>

            <template #field(low)="{ row }">
              <b-form-input
                v-model="row.low"
                type="text"
                placeholder="Low"
              />
            </template>

            <template #field(high)="{ row }">
              <b-form-input
                v-model="row.high"
                type="text"
                placeholder="High"
              />
            </template>
          </AnalyteRangeFormRow>
        </template>

        <b-row v-else class="py-2 align-items-center bg-light">
          <b-col>
            <div class="text-center text-muted">
              No Analyte Ranges Found
            </div>
          </b-col>
        </b-row>

      </b-card-body>
    </b-overlay>
  </b-card>
</template>

<script>
import AnalyteRangeFormRow from './AnalyteRangeFormRow.vue'

export default {
  name: 'AnalyteRangeFormFeedEdit',
  components: {
    AnalyteRangeFormRow
  },
  props: {
    analyte_ranges: {
      type: Array,
      default: () => []
    },
    loading_analyte_ranges: {
      type: Boolean,
      default: true
    }
  }
}
</script>
